import dayjs from 'dayjs';

import type { BannerRootData } from '../schemas/bannerSchema';
import {
  type BannerApiItem,
  BannerDestinationType,
  BannerPlatform,
  BannerSegment,
  BannerSlot,
  DeviceTypeEnum,
} from '../types/bannerManagement';

const deviceToPlatformMap: Record<DeviceTypeEnum, BannerPlatform> = {
  [DeviceTypeEnum.WEB]: BannerPlatform.Web,
  [DeviceTypeEnum.MOBILE]: BannerPlatform.Mobile,
  [DeviceTypeEnum.TABLET]: BannerPlatform.Tablet,
  [DeviceTypeEnum.TV]: BannerPlatform.TV,
};

function resolveDestinationType(banner: BannerApiItem): BannerDestinationType {
  if (banner.productId) {
    return BannerDestinationType.Product;
  }

  if (banner.categoryId) {
    return BannerDestinationType.Category;
  }

  return BannerDestinationType.Link;
}

export function toBannerFormValues(banner: BannerApiItem): BannerRootData {
  const destinationType = resolveDestinationType(banner);

  return {
    configuration: {
      platform: deviceToPlatformMap[banner.deviceType],
      segment: banner.targetMarket as BannerSegment,
      slotType: banner.slotType as BannerSlot,
    } as BannerRootData['configuration'],
    content: {
      name: banner.title,
      images: {
        web: {
          preview: banner.images?.web ?? '',
          file: undefined,
        },
        tablet: {
          preview: banner.images?.tablet ?? '',
          file: undefined,
        },
        mobile: {
          preview: banner.images?.mobile ?? '',
          file: undefined,
        },
        single: {
          preview: banner.images?.middle ?? banner.images?.bottom ?? '',
          file: undefined,
        },
      },
      destinationType,
      destinationLink:
        destinationType === BannerDestinationType.Link ? banner.link : '',
      destinationProduct:
        destinationType === BannerDestinationType.Product
          ? String(banner.productId)
          : '',
      destinationCategory:
        destinationType === BannerDestinationType.Category
          ? String(banner.categoryId)
          : '',
    },
    schedule: {
      publishType: 'scheduled',
      scheduledDate: banner.effectiveDate
        ? dayjs(banner.effectiveDate)
        : undefined,
      scheduledTime: banner.expirationDate
        ? dayjs(banner.expirationDate)
        : undefined,
      isActive: banner.status === 'activated' || banner.status === 'scheduled',
      withoutEndDate: !banner.expirationDate,
    },
  };
}
